module.exports = __webpack_public_path__ + "static/media/screenshot-5.d101697e.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-5.png
// module id = 690
// module chunks = 2